import { FC, useState, useEffect } from "react";
import { Input, Modal, Form, InputNumber } from "antd";

import {
  CreateCustomerModel,
  CustomerModel,
  UpdatedCustomerModel,
} from "states/customer/customer.models";
import { addCustomer, updateCustomer } from "states/customer/customer.api";
import { Store } from "antd/lib/form/interface";
import { useForm } from "antd/lib/form/Form";
import { t, CoreResource } from "shared/plugins/localization";
interface ICustomerModalProps {
  model: CustomerModel;
  onModal: boolean;
  closeModal: () => void;
  onSuccess: (customerId?: number) => void;
  isUpdate: boolean;
}
export const CustomerModalComponent: FC<ICustomerModalProps> = (props) => {
  const { model, onModal, closeModal, onSuccess, isUpdate } = props;
  const [form] = useForm();
  const [isLoading, setLoading] = useState(false);
  const handleCloseModal = () => closeModal();
  const onFinish = async (values: Store) => {
    setLoading(true);
    try {
      let customerId = 0;
      if (isUpdate) {
        customerId = model.id;
        let payload: UpdatedCustomerModel = {
          ...values,
          id: values.id,
          firstName: values.firstName.toUpperCase(),
          lastName: values.lastName.toUpperCase(),
          phoneNumber: values.phoneNumber,
          email: values.email,
          dayOfBirth: values.dayOfBirth ? Number(values.dayOfBirth) : undefined,
          monthOfBirth: values.dayOfBirth
            ? Number(values.monthOfBirth)
            : undefined,
          yearOfBirth: values.dayOfBirth
            ? Number(values.yearOfBirth)
            : undefined,
        };
        await updateCustomer(payload);
      } else {
        let payload: CreateCustomerModel = {
          ...values,
          firstName: values.firstName.toUpperCase(),
          lastName: values.lastName.toUpperCase(),
          phoneNumber: values.phoneNumber,
          email: values.email,
          dayOfBirth: values.dayOfBirth ? Number(values.dayOfBirth) : undefined,
          monthOfBirth: values.dayOfBirth
            ? Number(values.monthOfBirth)
            : undefined,
          yearOfBirth: values.dayOfBirth
            ? Number(values.yearOfBirth)
            : undefined,
        };
        const res = await addCustomer(payload);
        customerId = res.data;
      }
      handleCloseModal();
      setLoading(false);
      Modal.success({
        title: "Thành công",
        content: "Cập nhật thành công",
      });
      onSuccess(customerId);
    } catch (error) {
      Modal.error({
        title: "Thông báo",
        content:
          error?.response?.data?.error?.message ??
          "Lỗi hệ thống",
      });
      setLoading(false);
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const onSubmit = () => {
    form.submit();
  };
  const onReset = () => {
    form.resetFields();
  };
  const onFill = () => {
    form.setFieldsValue({
      id: model?.id,
      email: model?.email,
      phoneNumber: model?.phoneNumber,
      firstName: model?.firstName,
      lastName: model?.lastName,
      dayOfBirth: model?.dayOfBirth,
      monthOfBirth: model?.monthOfBirth,
      yearOfBirth: model?.yearOfBirth,
    });
  };

  useEffect(() => {
    if (!isUpdate) {
      onReset();
    } else {
      onFill();
    }
  }, [onModal]);

  return (
    <Modal
      title={
        <div
          style={{
            width: "100%",
            cursor: "move",
          }}
          onBlur={() => {}}
          // end
        >
          {isUpdate
            ? "Thêm khách hàng"
            : "Cập nhật thông tin"}
        </div>
      }
      confirmLoading={isLoading}
      centered={true}
      visible={onModal}
      onOk={onSubmit}
      onCancel={handleCloseModal}
      okText={"Lưu"}
      cancelText={"Hủy"}
    >
      <Form
        form={form}
        name="customerModal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        labelCol={{ span: 8 }}
        initialValues={{ isActive: true }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          label={`Họ`}
          name="lastName"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập họ",
            },
          ]}
        >
          <Input className="w-100" placeholder={`Họ`} />
        </Form.Item>
        <Form.Item
          label={`Tên`}
          name="firstName"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên",
            },
          ]}
        >
          <Input className="w-100" placeholder={`Tên`}/>
        </Form.Item>

        <Form.Item label="Email" name="email">
          <Input
            className="w-100"
            placeholder={"Địa chỉ email"}
            disabled={isUpdate}
          />
        </Form.Item>
        <Form.Item
          label="Số điện thoại"
          name="phoneNumber"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập số điện thoại",
            },
          ]}
        >
          <Input
            className="w-100"
            placeholder={"Số điện thoại"}
            disabled={isUpdate}
          />
        </Form.Item>
        <Form.Item label={`Ngày sinh`} name="dayOfBirth">
          <InputNumber className="w-100" placeholder={`Ngày sinh`} />
        </Form.Item>
        <Form.Item label={`Tháng sinh`} name="monthOfBirth">
          <InputNumber className="w-100" placeholder={`Tháng sinh`} />
        </Form.Item>
        <Form.Item label={`Năm sinh`} name="yearOfBirth">
          <InputNumber className="w-100" placeholder={`Năm sinh`} />
        </Form.Item>
        <Form.Item hidden={true} name="id">
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
